<template>
    <table id="myTable" class="table order-list table-">
        <thead>
        <tr>
            <td class="">Item Name</td>
            <td class="">Demanded Quantity</td>
           
            <!-- <td class="" v-if="IsSupplyChain">Approved Quantity</td> -->
            <td class="">Minimum Level at COPC</td>
            <td class="">Available Stock at COPC</td>
            <!-- <td class="" v-if="IsSupplyChain">Available Quantity <sup>at Warehouse</sup></td> -->
            <td class="">Actions</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, index) in itemrows" :key="index">
            <td class="">
                <select name="ItemId[]" v-model="row.ItemId" class="form-control form-control-sm" required @change="retrieveAvailableQuantity(row.ItemId)">
                    <option v-for="(item, index) in items" :key="item.Id" :value="item.Id">{{ item.Name }}</option>
                </select>
            </td>
            <td class="">
                <input type="number" name="DemandedQuantity[]"  v-model="row.DemandedQuantity" class="form-control form-control-sm" required/>
            </td>
            
            <!-- <td class="" v-if="IsSupplyChain">
                <input type="number" name="ApprovedQuantity[]" maxlength="3" :readonly="!row.CanApproveQuantity" v-model="row.ApprovedQuantity" class="form-control form-control-sm" required/>
                <ul v-if="!row.CanApproveQuantity || row.ApprovedQuantity > row.AvailableQuantity">
                    <li v-if="!row.CanApproveQuantity" style="color: red;"><span class="font-italic text-danger font-weight-700">* No available quantity</span></li>
                <li v-if="row.ApprovedQuantity > row.AvailableQuantity" style="color: red;"> <span class="font-italic text-danger font-weight-700">* Quantity limit exceeds.</span></li>
                </ul>

            </td> -->
            <td class="">
                <input type="number" name="MinimalLevelQuantity[]"  v-model="row.MinimalLevelQuantity" class="form-control form-control-sm"/>
            </td>
            <td class="">
                <input type="number" name="AvailableQuantity[]"  v-model="row.AvailableQuantity" class="form-control form-control-sm" readonly/>
            </td>
            <!-- <td class="" v-if="IsSupplyChain">
                <input type="number" name="AvailableQuantity[]"  v-model="row.AvailableQuantity" class="form-control form-control-sm" readonly/>
            </td> -->
            <td class="">
                <a class="btn btn-sm btn-danger text-white" @click="removeRow(index, row)"><i class="fas fa-trash-alt"></i></a>
            </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
            <td colspan="5" style="text-align: left;">
                <button type="button" class="btn btn-lg btn-block btn-outline-info" v-on:click="addNewItemRow()" id="addrow">
                    Add row
                </button>
            </td>
        </tr>
        </tfoot>
    </table>
</template>
<script>
    export default {
        name : 'inventory-request-item-list',
        props : ['items', 'inventoryRequestId'],
        data(){
            return {
                URLInventoryRequestItemPost: 'inventory-requests/items/available-quantity',
                itemrows: [
                    {
                        Id : null,
                        ItemId: null,
                        DemandedQuantity: null,
                        MinimalLevelQuantity: null,
                        ApprovedQuantity: null,
                        AvailableQuantity: null,
                    }
                ],
                submitted:false
            }
        },
        methods:{
            retrieveAvailableQuantity: function(itemId)
            {
                const index = this.itemrows.findIndex(project => project.ItemId == itemId);
                axios.post(this.URLInventoryRequestItemPost + '/' + this.inventoryRequestId, { "ItemId" : itemId })
                .then(response => {
                    
                    this.itemrows[index].AvailableQuantity = response.data.data;

                }).
            catch(error => {
                this.errored = true
            })
            .finally(() => this.loading = false)
            },
            addNewItemRow: function(){
                this.itemrows.push({
                    Id : null,
                    ItemId: null,
                    DemandedQuantity: null,
                    AvailableQuantity: null,
                    MinimumLevel: null,
                    ApprovedQuantity: null,
                });

                this.itemrows = this.checkUniqueItems(this.itemrows, 'ItemId')
            },
            removeRow: function(row){
                this.itemrows.splice(row, 1);
            },
            checkUniqueItems: function(arr, key){
                var uniqueItems = [...new Map(arr.map(item => [item[key], item])).values()]
                return uniqueItems;
            }
        },
        mounted() {
        },
    }
</script>
